import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.CARDS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                CARDLESS_WITHDRAW               *
*********************************************** */
{
	path: routeList.CARDS_CARDLESS_WITHDRAW_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_NAME,
	props: true,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_GENERATE_CODE_NAME,
	props: true,
	component: () => import('@/views/cards/cardlessWithdraw/GenerateCode')
}, {
	path: routeList.CARDS_CARDLESS_WITHDRAW_MY_CODES_PATH,
	name: routeList.CARDS_CARDLESS_WITHDRAW_MY_CODES_NAME,
	props: true,
	component: () => import('@/views/cards/cardlessWithdraw/MyCodes')
},
/* ***********************************************
*                     MY CARDS                   *
*********************************************** */
{
	path: routeList.CARDS_CONSULT_PATH,
	name: routeList.CARDS_CONSULT_NAME,
	props: true,
	component: () => import('@/views/cards/Consult')
},
{
	path: routeList.CARDS_CANCEL_PATH,
	name: routeList.CARDS_CANCEL_NAME,
	props: true,
	component: () => import('@/views/cards/Cancel')
},
{
	path: routeList.CARDS_CONSULT_CANCEL_PATH,
	name: routeList.CARDS_CONSULT_CANCEL_NAME,
	props: true,
	component: () => import('@/views/cards/Cancel')
},
{
	path: routeList.CARDS_CHANGE_PAYMENT_PATH,
	name: routeList.CARDS_CHANGE_PAYMENT_NAME,
	props: true,
	component: () => import('@/views/cards/ChangePayment')
},
{
	path: routeList.CARDS_ANTICIPATE_PAYMENT_PATH,
	name: routeList.CARDS_ANTICIPATE_PAYMENT_NAME,
	props: true,
	component: () => import('@/views/cards/AnticipatePayment')
},
{
	path: routeList.CARDS_CONSULT_BLOCK_PATH,
	name: routeList.CARDS_CONSULT_BLOCK_NAME,
	props: true,
	component: () => import('@/views/cards/Block')
},
{
	path: routeList.CARDS_LIMITS_PATH,
	name: routeList.CARDS_LIMITS_NAME,
	props: true,
	component: () => import('@/views/cards/Limits')
},
{
    path: routeList.CARDS_ACTIVATE_PATH,
	name: routeList.CARDS_ACTIVATE_NAME,
	props: true,
	component: () => import('@/views/cards/Activate')
},
/* ***********************************************
*                    TRANSFER                    *
*********************************************** */
{
	path: routeList.CARDS_TRANSFERS_FLEX_PATH,
	name: routeList.CARDS_TRANSFERS_FLEX_NAME,
	component: () => import('@/views/cards/transfer/Flex')
},
/* ***********************************************
*                      CHARGE                    *
*********************************************** */
{
	path: routeList.CARDS_CHARGE_PREPAID_PATH,
	name: routeList.CARDS_CHARGE_PREPAID_NAME,
	props: true,
	component: () => import('@/views/cards/charge/Prepaid')
},
/* ***********************************************
*                      CHARGE                    *
*********************************************** */
{
	path: routeList.CARDS_BLOCK_PATH,
	name: routeList.CARDS_BLOCK_NAME,
	component: () => import('@/views/cards/Block')
},
/* ***********************************************
*                      REQUEST                   *
*********************************************** */
{
	path: routeList.CARDS_REQUEST_PATH,
	name: routeList.CARDS_REQUEST_NAME,
	props: true,
	component: () => import('@/views/cards/request/RequestListTypes')
},
{
	path: routeList.CARDS_REQUEST_CARD_GENERIC_PATH,
	name: routeList.CARDS_REQUEST_CARD_GENERIC_NAME,
	props: true,
	component: () => import('@/views/cards/request/GenericCard'),
    beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CARDS_REQUEST_NAME)
	}
},
{
	path: routeList.CARDS_REQUEST_CARD_CVISA_VIRT_PATH,
	name: routeList.CARDS_REQUEST_CARD_CVISA_VIRT_NAME,
	props: true,
	component: () => import('@/views/cards/request/VirtualCard'),
    beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CARDS_REQUEST_NAME)
	}
},
/* ***********************************************
*                     BATCHFILE                  *
*********************************************** */
{
	path: routeList.CARDS_BATCHFILE_PATH,
	name: routeList.CARDS_BATCHFILE_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ****************** Consult ***************** */
{
	path: routeList.CARDS_BATCHFILE_CONSULT_FLEX_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_FLEX_NAME,
	component: () => import('@/views/cards/batchfile/consult/Flex')
}, {
	path: routeList.CARDS_BATCHFILE_CONSULT_KAMBA_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_KAMBA_NAME,
	component: () => import('@/views/cards/batchfile/consult/Kamba')
}, {
	path: routeList.CARDS_BATCHFILE_CONSULT_MULTICAIXA_PATH,
	name: routeList.CARDS_BATCHFILE_CONSULT_MULTICAIXA_NAME,
	component: () => import('@/views/cards/batchfile/consult/Multicaixa')
},
/* ****************** New Charge ***************** */
{
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_NAME,
	component: () => import('@/views/ThirdLevelMenu')
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_FLEX_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_FLEX_NAME,
	component: () => import('@/views/cards/batchfile/NewCharge')
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_KAMBA_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_KAMBA_NAME,
	component: () => import('@/views/cards/batchfile/NewCharge')
}, {
	path: routeList.CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_PATH,
	name: routeList.CARDS_BATCHFILE_NEW_CHARGE_MULTICAIXA_NAME,
	component: () => import('@/views/cards/batchfile/NewCharge')
},
/* ***********************************************
*********************************************** */
{
    path: routeList.CARDS_HISTORY_PATH,
    name: routeList.CARDS_HISTORY_NAME,
    props: true,
    component: () => import('@/views/cards/History')
}]
